import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Admin/Admin.css";

const API_URL = "https://aadyaacademy.org/api";

function Admin() {
  const [data, setData] = useState({
    announcements: [],
    circulars: [],
    classes: [],
    sections: [],
    departments: [],
    subjects: [],
  });

  const [previousData, setPreviousData] = useState(null);
  const [submittedData, setSubmittedData] = useState(null);

  const handleChange = (e, key) => {
    const inputValues = e.target.value
      .split(",")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
    setData({
      ...data,
      [key]: inputValues,
    });
  };

  const fetchPreviousData = async () => {
    try {
      const response = await axios.get(`${API_URL}/admin-data`);
      if (response.data) {
        setPreviousData(response.data);
      }
    } catch (err) {
      console.error("Failed to fetch previous admin data", err);
    }
  };

  const handleDelete = async (type, id) => {
    const confirmDelete = window.confirm(`Are you sure you want to delete this item from ${type}?`);
    if (!confirmDelete) return;

    try {
      await axios.delete(`${API_URL}/admin-data/${type}/${id}`);
      toast.success(`Deleted successfully from ${type}`);
      fetchPreviousData();
    } catch (error) {
      console.error(`Error deleting from ${type}`, error);
      toast.error(`Failed to delete from ${type}`);
    }
  };

  useEffect(() => {
    fetchPreviousData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/admin-data`, data);
      if (response.data && response.data.message) {
        toast.success(response.data.message);
      }
      setSubmittedData(data);
      toast.info(`Added: 
        Announcements: ${data.announcements.join(", ") || 'No announcements added'}, 
        Circulars: ${data.circulars.join(", ") || 'No circulars added'}, 
        Classes: ${data.classes.join(", ") || 'No classes added'}, 
        Sections: ${data.sections.join(", ") || 'No sections added'}, 
        Departments: ${data.departments.join(", ") || 'No departments added'}, 
        Subjects: ${data.subjects.join(", ") || 'No subjects added'}`);
      fetchPreviousData();
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Failed to submit data.");
    }
  };

  const renderPreviousItems = (items, type, keyName = "name") =>
    items?.map((item) => (
      <span key={item.id} className="previous-item-box">
        <span className="item-name">{item[keyName]}</span>
        <button
          type="button"
          className="delete-btn"
          onClick={() => handleDelete(type, item.id)}
        >
          ✖️
        </button>
      </span>
    ));

  return (
    <div className="admin">
      <div className="admin-c">
        <h2>Admin</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-div">
            <h4>Announcement Categories (e.g., General, Updates):</h4>
            <input
              type="text"
              onChange={(e) => handleChange(e, "announcements")}
              placeholder="Separate categories with commas"
            />
            <div className="previous-data">
              {renderPreviousItems(previousData?.categories, "categories")}
            </div>
          </div>

          <div className="form-div">
            <h4>Circular Categories (e.g., Notices, Events):</h4>
            <input
              type="text"
              onChange={(e) => handleChange(e, "circulars")}
              placeholder="Separate categories with commas"
            />
            <div className="previous-data">
              {renderPreviousItems(previousData?.circular_categories, "circular_categories")}
            </div>
          </div>

          <div className="form-div">
            <h4>Classes (e.g., 1, 2, 3):</h4>
            <input
              type="text"
              onChange={(e) => handleChange(e, "classes")}
              placeholder="Separate classes with commas"
            />
            <div className="previous-data">
              {renderPreviousItems(previousData?.classes, "classes")}
            </div>
          </div>

          <div className="form-div">
            <h4>Sections (e.g., A, B, C):</h4>
            <input
              type="text"
              onChange={(e) => handleChange(e, "sections")}
              placeholder="Separate sections with commas"
            />
            <div className="previous-data">
              {renderPreviousItems(previousData?.sections, "sections")}
            </div>
          </div>

          <div className="form-div">
            <h4>Departments (e.g., HR, Finance):</h4>
            <input
              type="text"
              onChange={(e) => handleChange(e, "departments")}
              placeholder="Separate departments with commas"
            />
            <div className="previous-data">
              {renderPreviousItems(previousData?.departments, "departments", "names")}
            </div>
          </div>

          <div className="form-div">
            <h4>Subjects (e.g., Math, Science):</h4>
            <input
              type="text"
              onChange={(e) => handleChange(e, "subjects")}
              placeholder="Separate subjects with commas"
            />
            <div className="previous-data">
              {renderPreviousItems(previousData?.subjects, "subjects", "names")}
            </div>
          </div>

          <div className="form-buttons">
            <button type="submit" className="admin-submit">
              Submit
            </button>
            <button
              type="button"
              className="admin-cancel"
              onClick={() =>
                setData({
                  announcements: [],
                  circulars: [],
                  classes: [],
                  sections: [],
                  departments: [],
                  subjects: [],
                })
              }
            >
              Cancel
            </button>
          </div>
        </form>
        <ToastContainer />
      </div>
    </div>
  );
}

export default Admin;
